import { useQuery } from '@tanstack/react-query';
import { bookingApi, bookingKeys, type BookingListParams } from '@/features/booking/api/booking.api';
import { useRefetchAtContactUnlock } from '@/features/booking/hooks/useRefetchAtContactUnlock';

export function useTravelerBookings(
  params?: BookingListParams,
  options?: { enabled?: boolean }
) {
  const query = useQuery({
    queryKey: bookingKeys.list(params),
    queryFn: () => bookingApi.list(params),
    enabled: options?.enabled ?? true,
  });
  useRefetchAtContactUnlock(query.data?.data, query.refetch, query.dataUpdatedAt);
  return query;
}
